'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function init() {
  productImage();
  bindUIActions();
};

var productImage = function productImage() {
  (0, _jquery2.default)(_dom2.default.navProductLink).each(function () {
    var _this = this;

    var productHandle = (0, _jquery2.default)(this).attr('data-product-handle');
    var productImage = void 0;
    _jquery2.default.getJSON('/products/' + productHandle + '.js', function (product) {
      productImage = product.featured_image.replace('.png', '_416x350.png').replace('.jpg', '_416x350.jpg');
    }).done(function () {
      (0, _jquery2.default)(_this).attr('data-product-image', productImage);
    });
  });
};

var bindUIActions = function bindUIActions() {
  (0, _jquery2.default)(_dom2.default.navTrigger).on('click', function () {
    (0, _jquery2.default)(_dom2.default.nav).addClass('is-active');
    (0, _jquery2.default)(_dom2.default.overlay).addClass('nav-is-active');
    (0, _jquery2.default)('body').addClass('nav-is-active');
    (0, _jquery2.default)(_dom2.default.siteContainer).addClass('nav-is-active');

    var headerOffset = (0, _jquery2.default)(_dom2.default.headerMarker).offset().top;

    if (headerOffset > (0, _jquery2.default)(window).scrollTop()) {
      (0, _jquery2.default)('html, body').animate({
        scrollTop: headerOffset
      }, 500);
    }
  });

  (0, _jquery2.default)(_dom2.default.navCloseTrigger).on('click', function () {
    (0, _jquery2.default)(_dom2.default.nav).removeClass('is-active');
    (0, _jquery2.default)(_dom2.default.overlay).removeClass('nav-is-active');
    (0, _jquery2.default)('body').removeClass('nav-is-active');
    (0, _jquery2.default)(_dom2.default.siteContainer).removeClass('nav-is-active');
  });

  (0, _jquery2.default)(_dom2.default.navDropdownTrigger).on('mouseenter', function () {
    (0, _jquery2.default)(this).addClass('nav-focus');
    (0, _jquery2.default)(_dom2.default.overlay).addClass('nav-is-active');
  });

  (0, _jquery2.default)(_dom2.default.navDropdownTrigger).on('mouseleave', function () {
    (0, _jquery2.default)(this).removeClass('nav-focus');
    (0, _jquery2.default)(_dom2.default.overlay).removeClass('nav-is-active');
  });

  (0, _jquery2.default)(_dom2.default.overlay).on('click', function () {
    (0, _jquery2.default)(_dom2.default.nav).removeClass('is-active');
    (0, _jquery2.default)(_dom2.default.overlay).removeClass('nav-is-active');
    (0, _jquery2.default)('body').removeClass('nav-is-active');
    (0, _jquery2.default)(_dom2.default.siteContainer).removeClass('nav-is-active');
  });

  (0, _jquery2.default)(_dom2.default.navProductLink).on('mouseenter', function () {
    var currentImage = (0, _jquery2.default)(this).closest(_dom2.default.navDropdownColumn).find(_dom2.default.navDropdownImage).attr('src');
    var newImage = (0, _jquery2.default)(this).attr('data-product-image');

    if (currentImage != undefined && currentImage != newImage) {
      (0, _jquery2.default)(this).closest(_dom2.default.navDropdownColumn).find(_dom2.default.navDropdownImage).attr('src', newImage);
    }
  });
};